import { OptionsIcon } from "assets/icons/OptionsIcon";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { ModalConfirm } from "components/ModalConfirm/ModalConfirm";
import { UsuarioI } from "interfaces/Usuario";
import { Dropdown } from "react-bootstrap";
import { deleteUsuario } from "services/usuarios";

interface Props {
  elemento: UsuarioI;
  onClickEdit: (elemento: UsuarioI) => void;
  refreshTable: () => void;
}

export const UsuariosRowActions = ({
  elemento,
  onClickEdit,
  refreshTable,
}: Props) => {
  const handleDelete = async (id: string | number) => {
    try {
      await deleteUsuario(id);
      showSuccessToast("¡El usuario fue eliminado con éxito!");
      refreshTable();
    } catch (error) {
      showErrorToast("Error eliminando el usuario");
    }
  };

  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {/* <Dropdown.Item onClick={() => {}}>Ver usuario</Dropdown.Item> */}

        <Dropdown.Item onClick={() => onClickEdit(elemento)}>
          Editar
        </Dropdown.Item>

        <ModalConfirm
          title="Eliminar usuario"
          onConfirm={() => handleDelete(elemento.id)}
          message={
            <p>
              Estas por eliminar el usuario {elemento.nombre}{" "}
              {elemento.apellido} <br />
              <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
            </p>
          }
          renderButton={(handleShow: () => void) => (
            <Dropdown.Item onClick={handleShow}>Eliminar</Dropdown.Item>
          )}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
